import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { NotificationTopicGet } from "../../../models/NotificationTopic"
import { useHashTab } from "../../../../hooks/useHashTab"
import { TopicDetails } from "./details_tab/TopicDetails"

const returnURL = "/notifications#topics"

export function TopicContainer() {
  const { notificationTopicId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [notificationTopic, setNotificationTopic] = useState<NotificationTopicGet>()

  useEffect(() => {
    if (notificationTopicId) {
      digitalManagerApi
        .get<NotificationTopicGet>(`/notificationTopics/${notificationTopicId}`)
        .then((res) => {
          setNotificationTopic(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, notificationTopicId])

  if (!notificationTopicId) {
    return <Navigate to={returnURL} />
  }

  if (!notificationTopic) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: notificationTopic.name,
    label: "Notification topic ID",
    subtitle: notificationTopic.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <TopicDetails
          notificationTopic={notificationTopic}
          setNotificationTopic={setNotificationTopic}
        />
      )}
    </div>
  )
}
